import { render } from "./IdentifyPage.vue?vue&type=template&id=9222ba2e&scoped=true"
import script from "./IdentifyPage.vue?vue&type=script&lang=js"
export * from "./IdentifyPage.vue?vue&type=script&lang=js"

import "./IdentifyPage.vue?vue&type=style&index=0&id=9222ba2e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9222ba2e"]])

export default __exports__